// errors/ValidationError.ts
import { BaseError } from "./BaseError.js";
var ValidationError = class _ValidationError extends BaseError {
  static {
    this.DEFAULT_KEY = "noKeySet";
  }
  static {
    this._class = "ValidationError";
  }
  constructor(message, extensions = { key: _ValidationError.DEFAULT_KEY }) {
    const target = extensions.target;
    const source = extensions.source;
    delete extensions.target;
    delete extensions.source;
    if (!extensions.translationKey)
      extensions.translationKey = "validationError";
    super(message, extensions);
    this.target = target;
    this.source = source;
  }
};
export {
  ValidationError
};
